import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule, ChipModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { BadgeModule, LoaderModule } from '@progress/kendo-angular-indicators';
import {
  FormFieldModule,
  InputsModule,
  NumericTextBoxModule,
  TextBoxModule,
} from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { ContextMenuModule, MenuModule } from '@progress/kendo-angular-menu';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { CustomActionsModule } from 'src/app/shared/components/custom-actions/custom-actions.module';
import { DocumentUploadModule } from 'src/app/shared/components/document-upload/document-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EditContactInformationComponent } from './edit-contact-information/edit-contact-information.component';
import { ScheduleMeetingComponent } from './schedule-meeting/schedule-meeting.component';
import { StudentInfoComponent } from './student-info.component';

@NgModule({
  declarations: [
    StudentInfoComponent,
    EditContactInformationComponent,
    ScheduleMeetingComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    GridModule,
    ListViewModule,
    IconsModule,
    MenuModule,
    ButtonsModule,
    PopupModule,
    DropDownsModule,
    LabelModule,
    FormsModule,
    LayoutModule,
    FormFieldModule,
    NumericTextBoxModule,
    TextBoxModule,
    InputsModule,
    DateInputsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    BadgeModule,
    TooltipsModule,
    ChipModule,
    LoaderModule,
    TypographyModule,
    DialogsModule,
    ExcelModule,
    UploadsModule,
    DialogsModule,
    NotificationModule,
    ContextMenuModule,
    CustomActionsModule,
    SharedModule,
    DocumentUploadModule,
  ],
  exports: [
    StudentInfoComponent,
    EditContactInformationComponent,
    ScheduleMeetingComponent,
  ],
})
export class StudentInfoModule {}
